import * as React from 'react';
import { toPng } from 'html-to-image';
import { jsPDF } from 'jspdf';
import download from 'downloadjs';
import { ReactComponent as ExportIcon } from '../assets/icons/export-icon.svg';
import { GraphData, MultiMetricData } from '../types';
import exportFromJSON from 'export-from-json';

interface Props {
  graph: any[];
  data?: GraphData[] | MultiMetricData[] | undefined | null;
  showExportOptions: boolean;
  setShowExportOptions: (value: React.SetStateAction<boolean>) => void;
  fileName?: string;
  automationID?: string;
}

const Export = ({
  graph,
  data,
  fileName = 'untitled_graph',
  showExportOptions,
  setShowExportOptions,
  automationID
}: Props): React.ReactElement => {
  const handleImageExport = (element: any, type: string) => {
    if (!element && data) {
      type === 'csv'
        ? exportFromJSON({
            data,
            fileName,
            exportType: exportFromJSON.types.csv
          })
        : type === 'xls'
        ? exportFromJSON({
            data,
            fileName,
            exportType: exportFromJSON.types.xls
          })
        : null;
    }
    if (!element || !element.current) return;
    setShowExportOptions(!showExportOptions);
    // Converting the DOM parentRef to PNG
    toPng(element.current, {
      height: element.current.offsetHeight * 2,
      style: {
        transform: `scale(${2}) translate(${element.current.offsetWidth / 2 / 2}px, ${
          element.current.offsetHeight / 2 / 2
        }px)`
      },
      width: element.current.offsetWidth * 2
    })
      .then((dataUrl: any) => {
        if (type === 'application/pdf') {
          const pdf = new jsPDF();
          pdf.addImage(dataUrl, 'PNG', 0, 0, 210, 0, undefined, 'FAST');
          return pdf.save(`${fileName}.pdf`);
        }
        download(dataUrl, `${fileName}.png`);
      })
      .catch((error: any) => {
        console.error('oops, something went wrong!', error);
      });
  };
  const exportCapture = (el: any, type: string): void => {
    setShowExportOptions(false);
    setTimeout(handleImageExport, 0, el, type);
  };
  const paragraphClasses =
    'cursor-pointer m-0 w-[175px] text-xs leading-[18px] font-nunitoMedium text-fontBlock py-[15px] px-2.5 hover:bg-opaqueNavy hover:text-navy hover:rounded';
  return (
    <>
      <ExportIcon
        id={automationID}
        className="cursor-pointer fill-current text-navy"
        onClick={() => setShowExportOptions(!showExportOptions)}
      />
      {showExportOptions && (
        <div className="z-50 absolute right-0 top-[130%] bg-white border border-[#e1e1e1] box-border shadow-exportShadow rounded-[3px] p-[3px]">
          <p className={paragraphClasses} onClick={() => exportCapture(graph, 'png')}>
            Download PNG image
          </p>
          <p className={paragraphClasses} onClick={() => exportCapture(graph, 'application/pdf')}>
            Download PDF document
          </p>
          <p className={paragraphClasses} onClick={() => exportCapture(null, 'csv')}>
            Download CSV
          </p>
          {/* <CSVLink className={`${paragraphClasses} block`} data={JSON.stringify(data)} filename={fileName}>
            Download CSV
          </CSVLink> */}
          <p className={paragraphClasses} onClick={() => exportCapture(null, 'xls')}>
            Download XLS
          </p>
        </div>
      )}
    </>
  );
};

export default Export;
